import API from "../../../../services/api-request";
import state from "../../../../config/valtio/store";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Table, message } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import dayjs from "dayjs";
import FilterMenu from "./filter-menu";
import AddProductType from "./modal-add-product-type";
import EditProductType from "./modal-edit-product-type";
import "../../../../assets/css/style-table.css";

const { confirm } = Modal;

const ProductType = () => {
  const [dataProductType, setDataProductType] = useState([]);
  const [dataProductTypeFilter, setDataProductTypeFilter] = useState([]);
  const [selectedData, setSelectedData] = useState({});

  // Edit Modal Variable Function
  const [showEdit, setShowEdit] = useState(false);
  const onShowEdit = (val) => {
    setShowEdit(val);
  };

  // Add Modal Variable & Function
  const [showAdd, setShowAdd] = useState(false);
  const onShowAdd = (val) => {
    setShowAdd(val);
  };

  const getProductType = async () => {
    state.LOADING = true;

    await API.Get("product-type")
      .then((result) => {
        setDataProductType(result?.data);
        setDataProductTypeFilter(result?.data);
      })
      .catch((err) => {
        console.error(err);
        message.info("Failed Fetch Product Type Data!");
      });

    state.LOADING = false;
  };

  useEffect(() => {
    getProductType();
  }, []);

  // Delete Confirm
  const showDeleteConfirm = (data) => {
    confirm({
      title: `Delete ${data.name}`,
      icon: <ExclamationCircleFilled />,
      content: `Are you sure delete ${data.name}?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        API.Delete(`product-type/${data.id}`)
          .then(() => {
            message.success("Product Type has been deleted");
          })
          .catch((err) => {
            message.info("Failed delete Product Type");
            console.error(err);
          })
          .finally(() => {
            getProductType();
          });
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const columns = [
    {
      title: "No.",
      key: "id",
      width: 60,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Size",
      dataIndex: "size",
      key: "size",
      sorter: (a, b) => {
        if (a.size === null || a.size === "-") return 1;
        if (b.size === null || b.size === "-") return -1;
        return a.size.localeCompare(b.size);
      },
      render: (size) => (size ? size : "-"),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => {
        if (a.created_at === null || a.created_at === "-") return 1;
        if (b.created_at === null || b.created_at === "-") return -1;
        return a.created_at.localeCompare(b.created_at);
      },
      render: (created_at) =>
        created_at ? dayjs(created_at).format("YYYY-MM-DD HH:mm:ss") : "-",
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "updated_at",
      sorter: (a, b) => {
        if (a.updated_at === null || a.updated_at === "-") return 1;
        if (b.updated_at === null || b.updated_at === "-") return -1;
        return a.updated_at.localeCompare(b.updated_at);
      },
      render: (updated_at) =>
        updated_at ? dayjs(updated_at).format("YYYY-MM-DD HH:mm:ss") : "-",
    },
    {
      title: "Action",
      key: "action",
      width: 180,
      render: (data) => {
        return (
          <Row align="middle" gutter={[8, 8]}>
            <Col>
              <Button
                type="primary"
                onClick={() => {
                  setSelectedData({ ...data });
                  onShowEdit(true);
                }}
              >
                Edit
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm(data);
                }}
              >
                Delete
              </Button>
            </Col>
          </Row>
        );
      },
    },
  ];

  const onSearch = async (val) => {
    let data = dataProductType.filter((product) =>
      product.name.toLowerCase().includes(val.toLowerCase())
    );

    setDataProductTypeFilter(data);
  };

  const onClear = async (val) => {
    getProductType();
  };

  const rowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };

  return (
    <>
      <FilterMenu onShowAdd={onShowAdd} onSearch={onSearch} onClear={onClear} />

      {/* Product Type Table */}
      <Table
        rowKey="id"
        columns={columns}
        dataSource={dataProductTypeFilter}
        rowClassName={rowClassName}
        scroll={{
          x: 1000,
        }}
        size="large"
      />

      {/* Modal Add Product Type*/}
      <div
        style={{ display: "flex", justifyContent: "flex-end", margin: "8px 0" }}
      >
        <AddProductType
          showAdd={showAdd}
          onShowAdd={onShowAdd}
          onGetProductType={getProductType}
        />
      </div>

      {/* Modal Edit Product Type*/}
      <EditProductType
        showEdit={showEdit}
        onShowEdit={onShowEdit}
        onGetProductType={getProductType}
        selectedData={selectedData}
      />
    </>
  );
};

export default ProductType;
